// extracted by mini-css-extract-plugin
module.exports = {"Loader":"LoadingRing_Loader__27GRN","animate":"LoadingRing_animate__1MTRY"};